/* eslint-disable no-underscore-dangle */
import { Flex, SimpleGrid, Text } from '@chakra-ui/react';
import ServiceItem from './ServiceItem';
import Navigation from '@components/Shared/Navigation';
import SanityImage from '@components/Shared/SanityImage';
import SanityText from '@components/Shared/SanityText';
import SectionHeader from '@components/Shared/SectionHeader';
import SectionWrapper from '@components/Shared/SectionWrapper';
import { ServiceQuery } from '@src/generated/graphql';
import { DeepExtractTypeSkipArrays } from '@src/types/extract-types';
import { NavigationButton } from '@components/Shared/NavigationButton';
import getButtonUrl from '@helpers/getButtonUrl';
import {
  ShowIfDesktop,
  ShowIfMobile,
} from '@components/Homepage/Header/styles';

const MyServices: React.FC<
  DeepExtractTypeSkipArrays<ServiceQuery, ['allServices']>
> = ({
  title,
  topTextRaw,
  mainImage,
  middleTextRaw,
  serviceItems,
  button,
  mainImageMobile,
}) => {
  const [normal, bold] = title?.split(' ') ?? ['', ''];
  return (
    <>
      <Navigation />
      <SectionWrapper>
        <Flex direction="column">
          <Flex mt="130px" mb="60px" justify="center">
            <SectionHeader normalText={normal} boldText={bold} />
          </Flex>
          <SanityText content={topTextRaw} mb="71px" />
          <ShowIfDesktop>
            <SanityImage sanityImage={mainImage} />
          </ShowIfDesktop>
          <ShowIfMobile>
            <SanityImage sanityImage={mainImageMobile} />
          </ShowIfMobile>
          <SanityText content={middleTextRaw} my="71px" />
          <SimpleGrid columns={[1, null, 2]} spacing="41px">
            {serviceItems?.map((service) => (
              <ServiceItem key={service?._key} {...service} />
            ))}
          </SimpleGrid>
          <NavigationButton
            href={getButtonUrl(button)}
            w="100%"
            my={['30px', null, '60px']}
          >
            <Text display={['none', null, 'block']}>{button?.text}</Text>
            <Text display={['block', null, 'none']}>{button?.mobileText}</Text>
          </NavigationButton>
        </Flex>
      </SectionWrapper>
    </>
  );
};

export default MyServices;
